/**
 * BotView logo component — the V-shaped mask icon.
 * Uses the logo file at /botview-logo.png
 */
export default function BotViewLogo({ size = 32, className = '' }) {
  return (
    <img
      src="/botview-logo.png"
      alt="BotView"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      draggable={false}
    />
  );
}
